import { ApiRoutes, QueryError } from '@/common/interfaces';
import { apiExecutor, buildMutation } from '@/common/services';

import { SearchConsoleIndexingQueryKeys } from '@/modules/Domains';

export const usePushIndexingPageMutation = (siteId: string) =>
  buildMutation<
    void, QueryError, { domainIds: string[]; pageId: string; }
  >([SearchConsoleIndexingQueryKeys.PushIndexing, siteId], async (postData) => {
    const { data } = await apiExecutor.post(
      ApiRoutes.SiteDomainsSearchConsolePushIndexing.replace(':siteId', siteId),
      { ...postData }
    );
    return data;
  });
